





































import CheckoutConfirmationViewModel from "@/chipply/view-model/CheckoutConfirmationViewModel";
import OrderItemDisplay from "@/components/OrderItemDisplay.vue";
import PriceDisplay from "./price/PriceDisplay.vue";
import Component from "vue-class-component";
import Vue from "vue";
import { Prop, Watch } from "vue-property-decorator";
import CheckoutReviewViewModel from "../chipply/view-model/CheckoutReviewViewModel";
import { IEcertBalanceInfo, Utils } from "chipply-common";
import OrderTotalSummary from "./price/OrderTotalSummary.vue";
import IPriceDisplay from "@/chipply/interface/IPriceDisplay";
import OrderItemSimpleDisplay from "./OrderItemSimpleDisplay.vue";

@Component({
    components: { OrderItemDisplay, OrderItemSimpleDisplay, PriceDisplay, OrderTotalSummary },
})
export default class OrderSummary extends Vue {
    public Utils = Utils;

    @Prop({ default: {} })
    public vm!: CheckoutReviewViewModel | CheckoutConfirmationViewModel;

    @Prop({ type: Boolean, default: true })
    public isSimple!: boolean;

    @Prop({ type: Boolean, default: false })
    public isConfirmationPage!: boolean;

    public get itemsStyle() {
        const baseStyle = {
            maxHeight: "300px",
            overflowY: "auto",
            overflowX: "hidden",
            // minHeight: "",
        };

        if (this.$vuetify.breakpoint.mdAndUp) {
            // baseStyle.minHeight = "430px";
        }
        return baseStyle;
    }

    public get priceDisplay(): IPriceDisplay {
        return {
            displayType: this.vm.branding.storePriceDisplayType,
            dollarValuePerPoint: this.vm.branding.storeDollarValuePerPoint ?? 0,
        };
    }

    public async handleApplyCode() {
        if (this.vm instanceof CheckoutReviewViewModel) {
            await this.vm.applyCodeAndRefresh();
        }
    }

    public handleDeletePromoCode() {
        if (this.vm instanceof CheckoutReviewViewModel) {
            this.vm.deletePromoCode();
        }
    }

    public handleDeleteEcertCode(ecert: IEcertBalanceInfo) {
        if (this.vm instanceof CheckoutReviewViewModel) {
            this.vm.deleteEcertCode(ecert);
        }
    }

    private get itemTotal() {
        let itemTotal = 0;
        this.vm.items.forEach((item) => {
            itemTotal += item.qty;
        });
        return itemTotal;
    }
}
